/**
 * <AccountTitleModal> — « Choisis un titre pour ton profil » (template).
 *
 * Une feuille, une option par quête : le titre que l'élève y a gagné, et où il en est. Toucher
 * une option la choisit ; pendant l'envoi elle reste marquée et les autres ne répondent plus.
 * C'est l'écran qui referme la feuille au succès, et qui dit l'échec (`<Snackbar>`).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Modal } from "../../molecules/Modal"
import { OptionCard } from "../../molecules/OptionCard"
import { type UIStudentTitleOption } from "../../../ports/primary/ui/types"

export type { UIStudentTitleOption }

export type AccountTitleModalProps = {
    visible: boolean
    onClose: () => void
    options: UIStudentTitleOption[]
    /** Le titre porté aujourd'hui. */
    selectedId?: string | number | null
    onSelect: (id: string | number) => void
    /** Le titre en cours d'envoi. */
    savingId?: string | number | null
    testID?: string
}

export function AccountTitleModal(props: AccountTitleModalProps) {
    const { visible, onClose, options, selectedId, onSelect, savingId, testID } = props

    const saving = savingId != null
    const shownId = savingId ?? selectedId

    return (
        <Modal
            testID={testID}
            visible={visible}
            onClose={onClose}
            title="Choisis un titre pour ton profil"
            // La tête d'une étape : la question passe à la ligne au lieu de buter sur la croix.
            steps={{ step: 1, total: 1 }}
            sizeToContent
            dismissable={!saving}
        >
            <Stack gap="2">
                {options.map((option) => (
                    <OptionCard
                        key={String(option.id)}
                        label={option.title}
                        description={option.detail}
                        selected={shownId != null && String(option.id) === String(shownId)}
                        disabled={saving && String(option.id) !== String(savingId)}
                        onPress={() => {
                            if (!saving) onSelect(option.id)
                        }}
                    />
                ))}
            </Stack>
        </Modal>
    )
}
